const account = [
    {
        expression: '/account/orders?type=:type&showLocal=:showLocal',
        args: {
            signal: require('./signals/pages/account/orders'),
            page: 'account',
            subPage: 'orders'
        }
    },
    {
        expression: '/account/orders/:orderId?type=:type',
        args: {
            signal: require('./signals/pages/account/orders'),
            page: 'account',
            subPage: 'orders'
        }
    },
    {
        expression: '/account/personal',
        args: {
            signal: require('./signals/pages/personal'),
            page: 'personal'
        }
    }
];

const manager = [
    {
        expression: '/manager/orders?status=:status&assigned=:assigned&text=:text&type=:type',
        args: {
            signal: require('./signals/pages/manager/orders'),
            page: 'manager',
            subPage: 'orders'
        }
    },
    {
        expression: '/manager/orders/:orderId?status=:status&assigned=:assigned&text=:text&type=:type',
        args: {
            signal: require('./signals/pages/manager/orders'),
            page: 'manager',
            subPage: 'orders'
        }
    },
    {
        expression: '/manager/users',
        args: {
            signal: require('./signals/pages/manager/users'),
            page: 'manager',
            subPage: 'users'
        }
    },
    {
        expression: '/manager/users/:userId',
        args: {
            signal: require('./signals/pages/manager/users'),
            page: 'manager',
            subPage: 'users'
        }
    },
    {
        expression: '/manager/orders/:orderId/statistic?isByBranch=:isByBranch&isTransposed=:isTransposed',
        args: {
            signal: require('./signals/pages/account/statistic'),
            page: 'statistic'
        }
    }
];

const auth = [
    {
        expression: '/login',
        args: {
            signal: require('./signals/pages/auth/login'),
            page: 'login'
        }
    },
    {
        expression: '/registration',
        args: {
            signal: require('./signals/pages/auth/registration'),
            page: 'registration'
        }
    },
    {
        expression: '/registration/extra',
        args: {
            signal: require('./signals/pages/auth/registration-extra'),
            page: 'registrationExtra'
        }
    },
    {
        expression: '/restorePassword',
        args: {
            signal: require('./signals/pages/auth/restore-password'),
            page: 'restore'
        }
    },
    {
        expression: '/restorePassword/:restoreToken',
        args: {
            signal: require('./signals/pages/auth/restore-change'),
            page: 'restoreChange'
        }
    },
    {
        expression: '/auth/confirmed',
        args: {
            signal: require('./signals/pages/auth/confirmed'),
            page: 'confirmed'
        }
    },
    {
        expression: '/auth/invalidToken',
        args: {
            signal: require('./signals/pages/auth/passport-error'),
            page: 'passportError'
        }
    },
    {
        expression: '/auth/serviceUnavailable',
        args: {
            signal: require('./signals/pages/auth/passport-error'),
            page: 'passportError'
        }
    }
];

const payments = [
    {
        expression: '/payment/:redirectType?orderNumber=:orderId',
        args: {
            signal: require('./signals/pages/payment'),
            page: 'payment'
        }
    }
];

const notFound = [
    {
        expression: /^.*$/,
        args: {
            signal: require('./signals/pages/errors').notFound,
            page: '404'
        }
    }
];

const routes = [
    {
        expression: '/',
        args: {
            signal: require('./signals/pages/order'),
            page: 'order'
        }
    },
    {
        expression: '/bitrix?DOMAIN=:bitrixDomain',
        args: {
            signal: require('./signals/pages/bitrixMain'),
            page: 'bitrixMain'
        }
    },
    {
        expression: '/contacts',
        args: {
            signal: require('./signals/pages/contacts'),
            page: 'contacts'
        }
    },
    {
        expression: '/help',
        args: {
            signal: require('./signals/pages/help'),
            page: 'help'
        }
    },
    {
        expression: '/terms',
        args: {
            signal: require('./signals/pages/terms'),
            page: 'terms'
        }
    },
    {
        expression: '/video',
        args: {
            signal: require('./signals/pages/video'),
            page: 'video'
        }
    },
    {
        expression: '/health',
        args: {
            signal: require('./signals/pages/health'),
            page: 'health'
        }
    },
    ...account,
    ...manager,
    ...auth,
    ...payments,
    ...notFound
];

module.exports = {
    /**
     * @param {Catbee} cat
     */
    register (cat) {
        routes.reverse().forEach((route) => cat.registerRoute(route));
    }
};



// WEBPACK FOOTER //
// ./routes.js